export const kanjiData = [
    {
        type: "Kanji",
        character: "一",
        pronunciation: "いち",
        meaning: "One",
        romaji: "ichi",
        strokes: 1,
        zones: [{ x: 10, y: 10, width: 50, height: 50 }]
      },
      {
        type: "Kanji",
        character: "二",
        pronunciation: "に",
        meaning: "Two",
        romaji: "ni",
        strokes: 2,
        zones: [{ x: 15, y: 15, width: 55, height: 55 }]
      },
      {
        type: "Kanji",
        character: "三",
        pronunciation: "さん",
        meaning: "Three",
        romaji: "san",
        strokes: 3,
        zones: [{ x: 20, y: 20, width: 60, height: 60 }]
      },
      {
        type: "Kanji",
        character: "四",
        pronunciation: "し",
        meaning: "Four",
        romaji: "shi",
        strokes: 5,
        zones: [{ x: 25, y: 25, width: 65, height: 65 }]
      },
      {
        type: "Kanji",
        character: "五",
        pronunciation: "ご",
        meaning: "Five",
        romaji: "go",
        strokes: 4,
        zones: [{ x: 30, y: 30, width: 70, height: 70 }]
      },
      {
        type: "Kanji",
        character: "六",
        pronunciation: "ろく",
        meaning: "Six",
        romaji: "roku",
        strokes: 4,
        zones: [{ x: 40, y: 40, width: 80, height: 80 }]
      },
      {
        type: "Kanji",
        character: "七",
        pronunciation: "しち",
        meaning: "Seven",
        romaji: "shichi",
        strokes: 2,
        zones: [{ x: 45, y: 45, width: 85, height: 85 }]
      },
      {
        type: "Kanji",
        character: "八",
        pronunciation: "はち",
        meaning: "Eight",
        romaji: "hachi",
        strokes: 2,
        zones: [{ x: 50, y: 50, width: 90, height: 90 }]
      },
      {
        type: "Kanji",
        character: "九",
        pronunciation: "きゅう",
        meaning: "Nine",
        romaji: "kyuu",
        strokes: 2,
        zones: [{ x: 55, y: 55, width: 95, height: 95 }]
      },
      {
        type: "Kanji",
        character: "十",
        pronunciation: "じゅう",
        meaning: "Ten",
        romaji: "juu",
        strokes: 2,
        zones: [{ x: 60, y: 60, width: 100, height: 100 }]
      },
      {
        type: "Kanji",
        character: "口",
        pronunciation: "くち",
        meaning: "Mouth",
        romaji: "kuchi",
        strokes: 3,
        zones: [{ x: 65, y: 65, width: 105, height: 105 }]
      },
      {
        type: "Kanji",
        character: "日",
        pronunciation: "にち",
        meaning: "Day, Sun",
        romaji: "nichi",
        strokes: 4,
        zones: [{ x: 70, y: 70, width: 110, height: 110 }]
      },
      {
        type: "Kanji",
        character: "月",
        pronunciation: "つき",
        meaning: "Month, Moon",
        romaji: "tsuki",
        strokes: 4,
        zones: [{ x: 75, y: 75, width: 115, height: 115 }]
      },
      {
        type: "Kanji",
        character: "田",
        pronunciation: "た",
        meaning: "Rice Field",
        romaji: "ta",
        strokes: 5,
        zones: [{ x: 80, y: 80, width: 120, height: 120 }]
      },
      {
        type: "Kanji",
        character: "目",
        pronunciation: "め",
        meaning: "Eye",
        romaji: "me",
        strokes: 5,
        zones: [{ x: 85, y: 85, width: 125, height: 125 }]
      },
      {
        type: "Kanji",
        character: "古",
        pronunciation: "こ",
        meaning: "Old",
        romaji: "ko",
        strokes: 5,
        zones: [{ x: 90, y: 90, width: 130, height: 130 }]
      },
      {
        type: "Kanji",
        character: "吾",
        pronunciation: "われ",
        meaning: "I, Myself",
        romaji: "ware",
        strokes: 7,
        zones: [{ x: 95, y: 95, width: 135, height: 135 }]
      },
      {
        type: "Kanji",
        character: "冒",
        pronunciation: "ぼう",
        meaning: "Risk",
        romaji: "bou",
        strokes: 9,
        zones: [{ x: 100, y: 100, width: 140, height: 140 }]
      },
      {
        type: "Kanji",
        character: "明",
        pronunciation: "めい",
        meaning: "Bright",
        romaji: "mei",
        strokes: 8,
        zones: [{ x: 105, y: 105, width: 145, height: 145 }]
      },
      {
        type: "Kanji",
        character: "唱",
        pronunciation: "しょう",
        meaning: "Chant",
        romaji: "shou",
        strokes: 11,
        zones: [{ x: 110, y: 110, width: 150, height: 150 }]
      },
      {
        type: "Kanji",
        character: "国",
        pronunciation: "こく",
        meaning: "Country",
        romaji: "koku",
        strokes: 8,
        zones: [{ x: 115, y: 115, width: 155, height: 155 }]
      },
      {
        type: "Kanji",
        character: "白",
        pronunciation: "はく",
        meaning: "White",
        romaji: "haku",
        strokes: 5,
        zones: [{ x: 120, y: 120, width: 160, height: 160 }]
      },
      {
        type: "Kanji",
        character: "天",
        pronunciation: "てん",
        meaning: "Heaven",
        romaji: "ten",
        strokes: 4,
        zones: [{ x: 125, y: 125, width: 165, height: 165 }]
      },
      {
        type: "Kanji",
        character: "母",
        pronunciation: "はは",
        meaning: "Mother",
        romaji: "haha",
        strokes: 5,
        zones: [{ x: 130, y: 130, width: 170, height: 170 }]
      },
      {
        type: "Kanji",
        character: "火",
        pronunciation: "ひ",
        meaning: "Fire",
        romaji: "hi",
        strokes: 4,
        zones: [{ x: 135, y: 135, width: 175, height: 175 }]
      },
      {
        type: "Kanji",
        character: "右",
        pronunciation: "う",
        meaning: "Right",
        romaji: "u",
        strokes: 5,
        zones: [{ x: 140, y: 140, width: 180, height: 180 }]
      },
      {
        type: "Kanji",
        character: "読",
        pronunciation: "どく",
        meaning: "Read",
        romaji: "doku",
        strokes: 14,
        zones: [{ x: 145, y: 145, width: 185, height: 185 }]
      },
      {
        type: "Kanji",
        character: "友",
        pronunciation: "とも",
        meaning: "Friend",
        romaji: "tomo",
        strokes: 4,
        zones: [{ x: 150, y: 150, width: 190, height: 190 }]
      },
      {
        type: "Kanji",
        character: "左",
        pronunciation: "ひだり",
        meaning: "Left",
        romaji: "hidari",
        strokes: 5,
        zones: [{ x: 155, y: 155, width: 195, height: 195 }]
      },
      {
        type: "Kanji",
        character: "有",
        pronunciation: "ゆう",
        meaning: "Have",
        romaji: "yuu",
        strokes: 6,
        zones: [{ x: 160, y: 160, width: 200, height: 200 }]
      },
      {
        type: "Kanji",
        character: "校",
        pronunciation: "こう",
        meaning: "School",
        romaji: "kou",
        strokes: 10,
        zones: [{ x: 165, y: 165, width: 205, height: 205 }]
      },
      {
        type: "Kanji",
        character: "語",
        pronunciation: "ご",
        meaning: "Language",
        romaji: "go",
        strokes: 14,
        zones: [{ x: 170, y: 170, width: 210, height: 210 }]
      },
      {
        type: "Kanji",
        character: "地",
        pronunciation: "ち",
        meaning: "Ground",
        romaji: "chi",
        strokes: 6,
        zones: [{ x: 175, y: 175, width: 215, height: 215 }]
      },
      {
        type: "Kanji",
        character: "全",
        pronunciation: "ぜん",
        meaning: "All",
        romaji: "zen",
        strokes: 6,
        zones: [{ x: 180, y: 180, width: 220, height: 220 }]
      },
      {
        type: "Kanji",
        character: "会",
        pronunciation: "かい",
        meaning: "Meet",
        romaji: "kai",
        strokes: 6,
        zones: [{ x: 185, y: 185, width: 225, height: 225 }]
      },
      {
        type: "Kanji",
        character: "何",
        pronunciation: "なに, なん",
        meaning: "What",
        romaji: "nani, nan",
        strokes: 7,
        zones: [{ x: 190, y: 190, width: 230, height: 230 }]
      },
      {
        type: "Kanji",
        character: "作",
        pronunciation: "さく",
        meaning: "Make",
        romaji: "saku",
        strokes: 7,
        zones: [{ x: 195, y: 195, width: 235, height: 235 }]
      },
      {
        type: "Kanji",
        character: "同",
        pronunciation: "どう",
        meaning: "Same",
        romaji: "dou",
        strokes: 6,
        zones: [{ x: 200, y: 200, width: 240, height: 240 }]
      },
      {
        type: "Kanji",
        character: "年",
        pronunciation: "ねん",
        meaning: "Year",
        romaji: "nen",
        strokes: 6,
        zones: [{ x: 205, y: 205, width: 245, height: 245 }]
      },
      {
        type: "Kanji",
        character: "内",
        pronunciation: "ない",
        meaning: "Inside",
        romaji: "nai",
        strokes: 4,
        zones: [{ x: 210, y: 210, width: 250, height: 250 }]
      },
      {
        type: "Kanji",
        character: "外",
        pronunciation: "がい, そと",
        meaning: "Outside",
        romaji: "gai, soto",
        strokes: 5,
        zones: [{ x: 215, y: 215, width: 255, height: 255 }]
      },
      {
        type: "Kanji",
        character: "間",
        pronunciation: "かん, あいだ",
        meaning: "Between",
        romaji: "kan, aida",
        strokes: 12,
        zones: [{ x: 220, y: 220, width: 260, height: 260 }]
      },
      {
        type: "Kanji",
        character: "前",
        pronunciation: "ぜん, まえ",
        meaning: "Before",
        romaji: "zen, mae",
        strokes: 9,
        zones: [{ x: 225, y: 225, width: 265, height: 265 }]
      },
      {
        type: "Kanji",
        character: "後",
        pronunciation: "ご, あと",
        meaning: "After",
        romaji: "go, ato",
        strokes: 9,
        zones: [{ x: 230, y: 230, width: 270, height: 270 }]
      },
      {
        type: "Kanji",
        character: "新",
        pronunciation: "しん",
        meaning: "New",
        romaji: "shin",
        strokes: 13,
        zones: [{ x: 235, y: 235, width: 275, height: 275 }]
      },
      {
        type: "Kanji",
        character: "方",
        pronunciation: "ほう",
        meaning: "Direction",
        romaji: "hou",
        strokes: 4,
        zones: [{ x: 240, y: 240, width: 280, height: 280 }]
      },
      {
        type: "Kanji",
        character: "明",
        pronunciation: "めい, みょう",
        meaning: "Bright",
        romaji: "mei, myou",
        strokes: 8,
        zones: [{ x: 245, y: 245, width: 285, height: 285 }]
      },
      {
        type: "Kanji",
        character: "思",
        pronunciation: "し",
        meaning: "Think",
        romaji: "shi",
        strokes: 9,
        zones: [{ x: 250, y: 250, width: 290, height: 290 }]
      },
      {
        type: "Kanji",
        character: "自",
        pronunciation: "じ",
        meaning: "Self",
        romaji: "ji",
        strokes: 7,
        zones: [{ x: 255, y: 255, width: 295, height: 295 }]
      },
      {
        type: "Kanji",
        character: "社",
        pronunciation: "しゃ",
        meaning: "Company, Society",
        romaji: "sha",
        strokes: 7,
        zones: [{ x: 260, y: 260, width: 300, height: 300 }]
      },
      {
        type: "Kanji",
        character: "見",
        pronunciation: "けん, みる",
        meaning: "See",
        romaji: "ken, miru",
        strokes: 7,
        zones: [{ x: 265, y: 265, width: 305, height: 305 }]
      },
      {
        type: "Kanji",
        character: "行",
        pronunciation: "こう, いく",
        meaning: "Go",
        romaji: "kou, iku",
        strokes: 6,
        zones: [{ x: 270, y: 270, width: 310, height: 310 }]
      },
      {
        type: "Kanji",
        character: "言",
        pronunciation: "げん, いい",
        meaning: "Say",
        romaji: "gen, iu",
        strokes: 7,
        zones: [{ x: 275, y: 275, width: 315, height: 315 }]
      },
      {
        type: "Kanji",
        character: "金",
        pronunciation: "きん",
        meaning: "Gold",
        romaji: "kin",
        strokes: 8,
        zones: [{ x: 280, y: 280, width: 320, height: 320 }]
      },
      {
        type: "Kanji",
        character: "来",
        pronunciation: "らい, くる",
        meaning: "Come",
        romaji: "rai, kuru",
        strokes: 7,
        zones: [{ x: 285, y: 285, width: 325, height: 325 }]
      },
      {
        type: "Kanji",
        character: "学",
        pronunciation: "がく, まなぶ",
        meaning: "Learn",
        romaji: "gaku, manabu",
        strokes: 8,
        zones: [{ x: 290, y: 290, width: 330, height: 330 }]
      },
      {
        type: "Kanji",
        character: "気",
        pronunciation: "き",
        meaning: "Spirit",
        romaji: "ki",
        strokes: 6,
        zones: [{ x: 295, y: 295, width: 335, height: 335 }]
      },
      {
        type: "Kanji",
        character: "北",
        pronunciation: "ほく",
        meaning: "North",
        romaji: "hoku",
        strokes: 5,
        zones: [{ x: 300, y: 300, width: 340, height: 340 }]
      },
      {
        type: "Kanji",
        character: "室",
        pronunciation: "しつ",
        meaning: "Room",
        romaji: "shitsu",
        strokes: 9,
        zones: [{ x: 305, y: 305, width: 345, height: 345 }]
      },
      {
        type: "Kanji",
        character: "家",
        pronunciation: "か, いえ",
        meaning: "House",
        romaji: "ka, ie",
        strokes: 10,
        zones: [{ x: 310, y: 310, width: 350, height: 350 }]
      },
      {
        type: "Kanji",
        character: "小",
        pronunciation: "しょう, ちいさい",
        meaning: "Small",
        romaji: "shou, chiisai",
        strokes: 3,
        zones: [{ x: 315, y: 315, width: 355, height: 355 }]
      },
      {
        type: "Kanji",
        character: "少",
        pronunciation: "しょう, すくない",
        meaning: "Few",
        romaji: "shou, sukunai",
        strokes: 4,
        zones: [{ x: 320, y: 320, width: 360, height: 360 }]
      },
      {
        type: "Kanji",
        character: "山",
        pronunciation: "さん, やま",
        meaning: "Mountain",
        romaji: "san, yama",
        strokes: 3,
        zones: [{ x: 325, y: 325, width: 365, height: 365 }]
      },
      {
        type: "Kanji",
        character: "川",
        pronunciation: "せん, かわ",
        meaning: "River",
        romaji: "sen, kawa",
        strokes: 3,
        zones: [{ x: 330, y: 330,width: 370, height: 370 }]
      },
      {
        type: "Kanji",
        character: "工",
        pronunciation: "こう",
        meaning: "Construction",
        romaji: "kou",
        strokes: 3,
        zones: [{ x: 335, y: 335, width: 375, height: 375 }]
      },
      {
        type: "Kanji",
        character: "弓",
        pronunciation: "きゅう",
        meaning: "Bow",
        romaji: "kyuu",
        strokes: 3,
        zones: [{ x: 340, y: 340, width: 380, height: 380 }]
      },
      {
        type: "Kanji",
        character: "引",
        pronunciation: "いん, ひく",
        meaning: "Pull",
        romaji: "in, hiku",
        strokes: 4,
        zones: [{ x: 345, y: 345, width: 385, height: 385 }]
      },
      {
        type: "Kanji",
        character: "天",
        pronunciation: "てん",
        meaning: "Heaven",
        romaji: "ten",
        strokes: 4,
        zones: [{ x: 345, y: 345, width: 385, height: 385 }]
      },
      {
        type: "Kanji",
        character: "生",
        pronunciation: "せい, いきる",
        meaning: "Life, To Live",
        romaji: "sei, ikiru",
        strokes: 5,
        zones: [{ x: 350, y: 350, width: 390, height: 390 }]
      },
      {
        type: "Kanji",
        character: "花",
        pronunciation: "か, はな",
        meaning: "Flower",
        romaji: "ka, hana",
        strokes: 7,
        zones: [{ x: 355, y: 355, width: 395, height: 395 }]
      },
      {
        type: "Kanji",
        character: "赤",
        pronunciation: "せき, あか",
        meaning: "Red",
        romaji: "seki, aka",
        strokes: 7,
        zones: [{ x: 360, y: 360, width: 400, height: 400 }]
      },
      {
        type: "Kanji",
        character: "青",
        pronunciation: "せい, あお",
        meaning: "Blue",
        romaji: "sei, ao",
        strokes: 8,
        zones: [{ x: 365, y: 365, width: 405, height: 405 }]
      },
      {
        type: "Kanji",
        character: "夕",
        pronunciation: "ゆう",
        meaning: "Evening",
        romaji: "yuu",
        strokes: 3,
        zones: [{ x: 370, y: 370, width: 410, height: 410 }]
      },
      {
        type: "Kanji",
        character: "石",
        pronunciation: "せき, いし",
        meaning: "Stone",
        romaji: "seki, ishi",
        strokes: 5,
        zones: [{ x: 375, y: 375, width: 415, height: 415 }]
      },
      {
        type: "Kanji",
        character: "走",
        pronunciation: "そう, はしる",
        meaning: "Run",
        romaji: "sou, hashiru",
        strokes: 7,
        zones: [{ x: 380, y: 380, width: 420, height: 420 }]
      },
      {
        type: "Kanji",
        character: "秋",
        pronunciation: "しゅう, あき",
        meaning: "Autumn",
        romaji: "shuu, aki",
        strokes: 9,
        zones: [{ x: 385, y: 385, width: 425, height: 425 }]
      },
      {
        type: "Kanji",
        character: "春",
        pronunciation: "しゅん, はる",
        meaning: "Spring",
        romaji: "shun, haru",
        strokes: 9,
        zones: [{ x: 390, y: 390, width: 430, height: 430 }]
      },
      {
        type: "Kanji",
        character: "夏",
        pronunciation: "か, なつ",
        meaning: "Summer",
        romaji: "ka, natsu",
        strokes: 10,
        zones: [{ x: 395, y: 395, width: 435, height: 435 }]
      },
      {
        type: "Kanji",
        character: "冬",
        pronunciation: "とう, ふゆ",
        meaning: "Winter",
        romaji: "tou, fuyu",
        strokes: 5,
        zones: [{ x: 400, y: 400, width: 440, height: 440 }]
      },
      {
        type: "Kanji",
        character: "多",
        pronunciation: "た, おおい",
        meaning: "Many",
        romaji: "ta, ooi",
        strokes: 6,
        zones: [{ x: 405, y: 405, width: 445, height: 445 }]
      },
      {
        type: "Kanji",
        character: "少",
        pronunciation: "しょう, すくない",
       meaning: "Few",
        romaji: "shou, sukunai",
        strokes: 4,
        zones: [{ x: 410, y: 410, width: 450, height: 450 }]
      },
      {
        type: "Kanji",
        character: "上",
        pronunciation: "じょう, うえ",
        meaning: "Above, Up",
        romaji: "jou, ue",
        strokes: 3,
        zones: [{ x: 415, y: 415, width: 455, height: 455 }]
      },
      {
        type: "Kanji",
        character: "下",
        pronunciation: "か, した",
        meaning: "Below, Down",
        romaji: "ka, shita",
        strokes: 3,
        zones: [{ x: 420, y: 420, width: 460, height: 460 }]
      },
      {
        type: "Kanji",
        character: "中",
        pronunciation: "ちゅう, なか",
        meaning: "Middle",
        romaji: "chuu, naka",
        strokes: 4,
        zones: [{ x: 425, y: 425, width: 465, height: 465 }]
      },
      {
        type: "Kanji",
        character: "大",
        pronunciation: "だい, おお",
        meaning: "Big",
        romaji: "dai, oo",
        strokes: 3,
        zones: [{ x: 430, y: 430, width: 470, height: 470 }]
      },
      {
        type: "Kanji",
        character: "小",
        pronunciation: "しょう, ちいさい",
        meaning: "Small",
        romaji: "shou, chiisai",
        strokes: 3,
        zones: [{ x: 435, y: 435, width: 475, height: 475 }]
      },
      {
        type: "Kanji",
        character: "高",
        pronunciation: "こう, たかい",
        meaning: "High, Tall",
        romaji: "kou, takai",
        strokes: 10,
        zones: [{ x: 440, y: 440, width: 480, height: 480 }]
      },
      {
        type: "Kanji",
        character: "長",
        pronunciation: "ちょう, ながい",
        meaning: "Long",
        romaji: "chou, nagai",
        strokes: 8,
        zones: [{ x: 445, y: 445, width: 485, height: 485 }]
      },
      {
        type: "Kanji",
        character: "出",
        pronunciation: "しゅつ, でる",
        meaning: "Exit, Leave",
        romaji: "shutsu, deru",
        strokes: 5,
        zones: [{ x: 450, y: 450, width: 490, height: 490 }]
      },
      {
        type: "Kanji",
        character: "入",
        pronunciation: "にゅう, はいる",
        meaning: "Enter, Insert",
        romaji: "nyuu, hairu",
        strokes: 2,
        zones: [{ x: 455, y: 455, width: 495, height: 495 }]
      },
      {
        type: "Kanji",
        character: "手",
        pronunciation: "しゅ, て",
        meaning: "Hand",
        romaji: "shu, te",
        strokes: 4,
        zones: [{ x: 460, y: 460, width: 500, height: 500 }]
      },
      {
        type: "Kanji",
        character: "足",
        pronunciation: "そく, あし",
        meaning: "Foot",
        romaji: "soku, ashi",
        strokes: 7,
        zones: [{ x: 465, y: 465, width: 505, height: 505 }]
      },
      {
        type: "Kanji",
        character: "目",
        pronunciation: "もく, め",
        meaning: "Eye",
        romaji: "moku, me",
        strokes: 5,
        zones: [{ x: 470, y: 470, width: 510, height: 510 }]
      },
      {
        type: "Kanji",
        character: "耳",
        pronunciation: "じ, みみ",
        meaning: "Ear",
        romaji: "ji, mimi",
        strokes: 6,
        zones: [{ x: 475, y: 475, width: 515, height: 515 }]
      },
      {
        type: "Kanji",
        character: "口",
        pronunciation: "こう, くち",
        meaning: "Mouth",
        romaji: "kou, kuchi",
        strokes: 3,
        zones: [{ x: 480, y: 480, width: 520, height: 520 }]
      },
      {
        type: "Kanji",
        character: "心",
        pronunciation: "しん, こころ",
        meaning: "Heart",
        romaji: "shin, kokoro",
        strokes: 4,
        zones: [{ x: 485, y: 485, width: 525, height: 525 }]
      },
      {
        type: "Kanji",
        character:"心",
        pronunciation: "しん, こころ",
        meaning: "Heart",
        romaji: "shin, kokoro",
        strokes: 4,
        zones: [{ x: 485, y: 485, width: 525, height: 525 }]
      },
      {
        type: "Kanji",
        character: "手",
        pronunciation: "しゅ, て",
        meaning: "Hand",
        romaji: "shu, te",
        strokes: 4,
        zones: [{ x: 490, y: 490, width: 530, height: 530 }]
      },
      {
        type: "Kanji",
        character: "立",
        pronunciation: "りつ, たつ",
        meaning: "Stand",
        romaji: "ritsu, tatsu",
        strokes: 5,
        zones: [{ x: 495, y: 495, width: 535, height: 535 }]
      },
      {
        type: "Kanji",
        character: "自",
        pronunciation: "じ, みずから",
        meaning: "Self",
        romaji: "ji, mizukara",
        strokes: 6,
        zones: [{ x: 500, y: 500, width: 540, height: 540 }]
      },
      {
        type: "Kanji",
        character: "友",
        pronunciation: "ゆう, とも",
        meaning: "Friend",
        romaji: "yuu, tomo",
        strokes: 4,
        zones: [{ x: 505, y: 505, width: 545, height: 545 }]
      },
      {
        type: "Kanji",
        character: "話",
        pronunciation: "わ, はなす",
        meaning: "Talk",
        romaji: "wa, hanasu",
        strokes: 13,
        zones: [{ x: 510, y: 510, width: 550, height: 550 }]
      }
      
]

export default kanjiData;